import { useState } from 'react';
import urlToHttp from '../utils/urlToHttp';
// const AWS_URL = 'https://image-compression-handler.s3.us-west-1.amazonaws.com/';
const AWS_CLOUDFRONT_URL = 'https://d3v21378787kni.cloudfront.net/';
export default function ImageProcessor({ src, size, ...props }) {
  // pass into src the url to the image
  // src format : ipfs://QmWjY...

  const [load, setLoad] = useState(false);
  const image_hash = src?.split('//')[1];
  return (
    <img
      src={AWS_CLOUDFRONT_URL + image_hash + '=' + size}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null; // prevents looping
        currentTarget.src = urlToHttp(src);
      }}
      {...props}
      alt="karatDao"
      style={load ? { visibility: 'visible' } : { visibility: 'hidden' }}
      onLoad={() => setLoad(true)}
    />
  );
}
